import styled from "styled-components";

export const NotificationsSectionSection = styled.div.attrs({ className: "mt-8" })``;

export const NotificationsSectionLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const NotificationsSectionMetaText = styled.p.attrs({
  className: "mt-1 text-xs text-[var(--brand-muted)]",
})``;
